export default "__VITE_ASSET__925e8d3b__"